<template>
  <div class="tw-p-4 tw-text-center" v-if="showNoAccessError">
    <div v-if="accessStatus == 'inactive'">
      <p v-if="isIndividual">
        Your account isn't active.
        <SfRouterLink to="/purchase/individual"
          >Reactivate your account</SfRouterLink
        >.
      </p>
      <div v-else>
        <p>You don't have an active account.</p>
        <p v-if="isStudent">Please discuss this with your teacher.</p>
        <div v-else-if="!isAdmin">
          <p>
            Please discuss this with your school administrator ({{
              $currentUser.value!.school!.adminName
            }}).
          </p>
          <p>
            If you need to change your school administrator <ContactLink />.
          </p>
        </div>
      </div>
    </div>
    <div v-else-if="mfMovedError">
      <MfJoinError error="mfUserMoved" class="tw-text-left">
        Use your Spellingframe credentials
      </MfJoinError>
    </div>
    <div v-else-if="accessStatus == 'nosubject'">
      <p v-if="currentSubject">
        You don't have access to {{ currentSubjectLabel }} area of the site.
      </p>
      <p v-else>You don't have access to this area of the site.</p>
      <p v-if="isStudent">Please discuss this with your teacher.</p>
      <div v-else-if="!isAdmin">
        <p>
          Please discuss this with your school administrator ({{
            $currentUser.value!.school!.adminName
          }}).
        </p>
        <p>If you need to change your school administrator <ContactLink />.</p>
      </div>
    </div>
    <p v-else>You have no access to this area.</p>
  </div>
  <div v-else-if="showFailedError">
    There was an error loading you user info. Please check your connection and
    try again. If the error continues please contact me at
    <a href="mailto:support@spellingframe.co.uk">support@spellingframe.co.uk</a>
  </div>
</template>

<script lang="ts">
import userHasRole from "@/func/user/userHasRole";
import { SfAccessStatus, SfSubject } from "@/types/generalTypes";
import { PropType } from "vue";
import { defineComponent } from "vue";
import SfRouterLink from "../shared/SfRouterLink.vue";
import MfJoinError from "../mathsframe/MfJoinError.vue";
import ContactLink from "../ui/ContactLink.vue";

export default defineComponent({
  components: { MfJoinError, SfRouterLink, ContactLink },
  props: {
    accessStatus: { type: String as PropType<SfAccessStatus>, default: "" },
    currentSubject: { type: String as PropType<SfSubject | "">, default: "" },
  },
  computed: {
    isAdmin() {
      return userHasRole(this.$currentUser.value, ["schoolAdmin"]);
    },
    isStudent() {
      return userHasRole(this.$currentUser.value, ["student"]);
    },
    isIndividual() {
      return userHasRole(this.$currentUser.value, ["individual"]);
    },
    showNoAccessError(): boolean {
      return this.$userLoadStatus.value == "loaded";
    },
    showFailedError(): boolean {
      return this.$userLoadStatus.value == "failed";
    },
    currentSubjectLabel() {
      switch (this.currentSubject) {
        case "mfGame":
          return "Mathsframe games";
        case "mfWs":
          return "Mathsframe worksheets";
      }
      return this.currentSubject;
    },
    mfMovedError() {
      if (!this.$currentUser.value?.mfUser) {
        return false;
      }
      if (this.$currentUser.value.mfUser.moved_to_sf_on == null) {
        return false;
      }
      return true;
    },
  },
});
</script>
